import React, { useEffect, useState } from "react";
import {
	Box,
	Button,
	Dialog,
	DialogContent,
	Stack,
	IconButton,
	DialogActions,
	List,
	ListItem,
	ListItemText,
} from "@mui/material";
import "../../css/empresa_uno/visitas.css";
import Grid from "@mui/material/Grid2";
import Divider from "@mui/material/Divider";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import { ModalForAll } from "../global/ModalForAll";
import { ArrowBack as ArrowBackIcon, ArrowForward as ArrowForwardIcon } from "@mui/icons-material";
import { ImagenesGlobal } from "../global/ImagenesGlobal";

export const ModalViewProductEmpresa = ({ onClose, product, isPrivileged = null, loadImageS, convertPrice = (() => { }) }) => {
	const [hoverIndex, setHoverIndex] = useState(null);
	const [isNonAdminView, setIsNonAdminView] = useState(true);

	const descriptionItems = product?.description
		? Object.entries(product?.description).map(([key, value]) => ({ key, value }))
		: [];

	const prices = [
		{ label: "Primer Precio", value: convertPrice(product?.price ?? 0.00), color: "var(--theme-company)" },
		{ label: "Segundo Precio", value: convertPrice(product?.price2 ?? 0.00) },
		{ label: "Tercer Precio", value: convertPrice(product?.price3 ?? 0.00) },
		{ label: "Precio Mayorista", value: convertPrice(product?.wholesale ?? 0.00) },
		{ label: "Precio Compra", value: convertPrice(product?.purchase_price ?? 0.00), color: "#28a745" },
	];

	const handleSwitchChange = (event) => {
		setIsNonAdminView(event.target.checked);
	};

	function modalClose() {
		onClose();
	}

	const listImg = product && Array.from(product?.images ?? []);
	const [currentImg, setCurrentImg] = useState(0);

	const handleNext = () => {
		setCurrentImg((prevIndex) => (prevIndex + 1) % listImg.length);
	};

	const handlePrev = () => {
		setCurrentImg((prevIndex) => (prevIndex === 0 ? listImg.length - 1 : prevIndex - 1));
	};

	useEffect(() => setCurrentImg(0), [product])

	return (
		<ModalForAll stateModal={Object.keys(product ?? {}).length > 0 ? true : false} setStateModal={modalClose} className='modal-default default-f-column' iconColor="#9e9e9e">
			{isPrivileged && (
				<FormControlLabel
					onChange={(e) => handleSwitchChange(e)}
					control={<Switch size="small" checked={isNonAdminView} />}
					label="Modo vendedor"
					sx={{ color: '#000000de' }}
				/>
			)}

			<Stack
				direction={{ xs: "column", sm: "row" }}
				spacing={{ xs: 1, sm: 2, md: 4 }}
				sx={{ justifyContent: "space-evenly", color: '#000000de' }}>

				<Box
					sx={{
						position: "relative",
						width: "100%",
						maxWidth: 500,
						height: "100%",
						margin: "auto",
						overflow: "hidden",
					}}>
					<Box
						sx={{
							flex: 1,
							width: "100%",
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							position: "relative",
							overflow: "hidden",
						}}>

						{
							listImg.map((url, index) => (
								<ImagenesGlobal url={listImg[index]} type="picture" loadImageS={loadImageS} style={{
									display: currentImg == index ? 'flex' : 'none',
									maxWidth: "100%",
									maxHeight: "100%",
									objectFit: "contain",
								}} />
							))
						}

						{listImg.length > 1 && (
							<>
								<IconButton
									onClick={handlePrev}
									sx={{
										"position": "absolute",
										"left": 10,
										"top": "50%",
										"transform": "translateY(-50%)",
										"backgroundColor": "rgba(0,0,0,0.5)",
										"color": "white",
										"&:hover": {
											backgroundColor: "rgba(0,0,0,0.7)",
										},
									}}>
									<ArrowBackIcon />
								</IconButton>
								<IconButton
									onClick={handleNext}
									sx={{
										"position": "absolute",
										"right": 10,
										"top": "50%",
										"transform": "translateY(-50%)",
										"backgroundColor": "rgba(0,0,0,0.5)",
										"color": "white",
										"&:hover": {
											backgroundColor: "rgba(0,0,0,0.7)",
										},
									}}>
									<ArrowForwardIcon />
								</IconButton>
							</>
						)}
					</Box>
				</Box>

				<Box>
					<h2 className="modal-title-viewProduct">{product?.name}</h2>
					<List dense={false}>
						<ListItemText>
							Código: <strong>{product?.code}</strong>
						</ListItemText>
						<ListItemText>
							Marca: <strong>{product?.brand}</strong>
						</ListItemText>
						<ListItemText>
							Categoria: <strong>{product?.category}</strong>
						</ListItemText>
						{!isNonAdminView && (
							<ListItemText>
								Ciudad: <strong>{product?.city ?? "Santa Cruz"}</strong>
							</ListItemText>
						)}
						{!isNonAdminView && (
							<ListItemText>
								Proveedor: <strong>{product?.supplierFullname}</strong>
							</ListItemText>
						)}
					</List>
					<ListItemText>Descripción:</ListItemText>
					<Divider />
					<Box sx={{ height: 'auto', overflowY: "hidden" }}>
						<ul
							style={{
								overflow: 'hidden auto',
								height: 'auto',
								maxHeight: '200px',
								listStyle: "none",
								padding: '5px 0px',
								margin: 0,
								fontSize: "1rem",
								lineHeight: "1.1", // Tighter line height
							}}>
							{descriptionItems.map((item) => (
								<li
									key={`${item.key}-${item.value}`}
									style={{
										padding: 0,
										margin: 0,
									}}>
									<span style={{ fontWeight: 550 }}>{item.key}:</span> {item.value}
								</li>
							))}
						</ul>
					</Box>
					<Grid container spacing={1} justifyContent="space-between" sx={{ mt: 1 }}>
						{prices.map(
							(price, index) =>
								(!isNonAdminView || price?.label !== "Precio Compra") && (
									<Grid item key={`${price?.value}${index}`}>
										<Button
											variant="outlined"
											sx={{
												"width": 100,
												"height": 40,
												"borderRadius": "30px",
												"border":
													index === 0 || index === 4
														? `2px solid ${price?.color || "#0468fb"}`
														: "none",
												"backgroundColor":
													index === 0 || index === 4 ? "white" : price?.color || "#0468fb",
												"color": price?.color || "#0468fb",
												"fontSize": "12px",
												"fontWeight": "bold",
												"transition": "0.3s",
												"&:hover":
													index !== 4
														? {
															backgroundColor: "white",
															color: price?.color || "#0468fb",
															border: `2px solid ${price?.color || "#0468fb"}`,
															padding: "8px",
														}
														: {},
											}}
											onMouseEnter={() => setHoverIndex(index)}
											onMouseLeave={() => setHoverIndex(null)}>
											{index === 0 || hoverIndex === index || (index === 4 && !isNonAdminView)
												? price?.value
												: ""}
										</Button>
										<div
											style={{
												textAlign: "center",
												marginTop: "2px",
												fontSize: "12px",
												fontWeight: "500",
												color: "#000",
												letterSpacing: "0.5px",
											}}>
											{price?.label}
										</div>
									</Grid>
								)
						)}
					</Grid>
				</Box>
			</Stack>
		</ModalForAll>
	);
};

/*


*/